import React from 'react';
import HtmlLegalDocumentPage from '../components/HtmlLegalDocumentPage';

export default function PrivacyPolicy() {
  return <HtmlLegalDocumentPage documentPath="/legal/privacy-policy.html" />;
}
